import { render, staticRenderFns } from "./AutomatorBlockEditor.vue?vue&type=template&id=0f454411&scoped=true&"
import script from "./AutomatorBlockEditor.vue?vue&type=script&lang=js&"
export * from "./AutomatorBlockEditor.vue?vue&type=script&lang=js&"
import style0 from "./AutomatorBlockEditor.vue?vue&type=style&index=0&id=0f454411&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f454411",
  null
  
)

export default component.exports